import { CompanyBranchForm } from "@/features/company/components/CompanyBranchForm";
import React, { FC } from "react";

type TCompanyBranchCreatePageProps = {};

export const CompanyBranchCreatePage: FC<TCompanyBranchCreatePageProps> = () => {
  return <CompanyBranchForm />;
};
